import { buildFilteredTableReportSheet } from './filtered-table-report'

const organizationExpandColumns = [
  { key: 'num', label: '#' },
  { key: 'division', label: 'Group	' },
  { key: 'faction', label: 'Division' },
  { key: 'department', label: 'Department' },
  { key: 'team_en', label: 'Team' },
  { key: 'level_id', label: 'Level' },
  { key: 'position_en', label: 'Position' },
  { key: 'headcount', label: 'Head Count	' },
  { key: 'count_emp', label: 'Count of Employee' }
]

export function buildOrganizationExpandReportSheet({
  filterEx = [],
  data = []
}) {
  return buildFilteredTableReportSheet({
    filterEx,
    data,
    columns: organizationExpandColumns,
    defaultFilterValue: '-'
  })
}
